/*
 * @Descripttion: API接口的统一出口
 * @Author: juanjuanhui
 * @Date: 2021-05-17 09:25:08
 * @LastEditors: liushumin lsm15501088391@163.com
 * @LastEditTime: 2024-11-20 15:17:55
 */
import http from 'utils/http'
import { base } from './base'
import { download ,downloadFile} from '@/utils/request'
// 登录
const login = {
  login(params, headers) {
    return http.post(`${base.request}/manage/account/login`, params, headers)
  },
}
const common = {
  /**
   * @description 模块保存
   * @Author quwandong
   * @Date 2023-10-17 18:46:13
   */
  updateModule(params) {
    return http.post(`${base.request}/module/updateModule`, params);
  },
  /**
   * @description
   * @Author quwandong
   * @Date 2023-10-17 10:49:44
   */
  selectOneLevelMenu(params) {
    return http.post(`${base.request}/module/moduleList`, params);
  },
  // 根据父id查询省市县乡村子地区
  getChildRegion(params) {
    return http.get(`${base.request}/village/selectChildRegion`, params)
  },
  //获取合作社/村集体列表（添加操作时用）
  getCompanyList(params) {
    return http.get(`${base.request}/coo/getCompanyList`, params)
  },
  // 获取业务区域
  getBusinessZoneList(params) {
    return http.post(`${base.request}/zone/selectMBusinessZoneList`, params)
  },
  //获取所有业务负责人
  getDutyPerson(params) {
    return http.get(`${base.request}/person/getDutyPerson`, params)
  },
  //识别营业执照
  disBusinessLicense(params) {
    return http.get(`${base.request}/xczx/identityBusinessLicense`, params)
  },
  //识别身份证
  disIdcard(params) {
    return http.get(`${base.request}/xczx/identityIdCard`, params)
  },
  // 获取合同附件
  getContractFileList(params) {
    return http.get(`${base.request}/contract/file/contractFileList`, params)
  },
  // 获取所有作物
  getAllCropList() {
    return http.get(`${base.request}/workTypeApi/getAllCropList`)
  },
  // 获取一级农机作业列表
  getCropWork(params) {
    return http.get(`${base.request}/workTypeApi/cropWork1`, params)
  },
  // 获取二级农机作业列表
  getCropWork2(params) {
    return http.get(`${base.request}/workTypeApi/cropWork2`, params)
  },
  // 获取权限树
  selectSMenuTree(params) {
    return http.post(`${base.request}/menu/selectSMenuTree`, params)
  },
  // 获取已选中权限树
  selectOwnSMenuTree(params) {
    return http.post(`${base.request}/menu/selectOwnSMenuTree`, params)
  },
  // 获取所有无子的村小组
  getVillGroups(params) {
    return http.get(`${base.request}/villGroup/sonVillGroup`, params)
  },
  getMachineCategorys(params) {
    return http.get(`${base.request}/machine/getMachineCategorys`, params)
  },
  getLocationByIp(params) {
    return http.get(`${base.request}/xczx/getLocationByIp`, params)
  },
}
const village = {
  // 村集体列表查询
  villageListFilter(params) {
    return http.post(`${base.request}/village/villageListPage`, params)
  },
  addVillage(params) {
    return http.post(`${base.request}/village/insertVillage`, params)
  },
  // 获取村集体一级组织
  oneLevelVillGroup(params) {
    return http.get(`${base.request}/villGroup/oneLevelVillGroup`, params)
  },
  // 人力资源-村民列表
  threeLevelVillGroup(params) {
    return http.get(`${base.request}/villagePerson/threeLevelVillGroup`, params)
  },
  // 人力资源-村民详情页信息
  getVillPersonDetail(params) {
    return http.get(
      `${base.request}/villagePerson/detailedShowOnePerson`,
      params
    )
  },
  // 获取村集体二级组织
  twoLevelVillGroup(params) {
    return http.get(`${base.request}/villGroup/twoLevelVillGroup`, params)
  },
  // 根据村集体id获取详情
  getVillageById(params) {
    return http.get(`${base.request}/village/getVillageById`, params)
  },
  // 土地资源-管理列表
  getLandList(params) {
    return http.get(`${base.request}/land/LandList`, params)
  },
  // 订单结算列表
  getOrderSettleList(params) {
    return http.post(`${base.request}/orderSettlement/orderList`, params)
  },
  // 获取审核列表
  getOrderList(params) {
    return http.get(
      `${base.request}/workAudit/getWorkTypeListByMasterId`,
      params
    )
  },
  // 订单结算详情-上半部分
  getOrderSettleDetail(params) {
    return http.get(`${base.request}/orderSettlement/orderDetails`, params)
  },
  // 订单结算详情-下半部分-支付记录
  getSettleRecordList(params) {
    return http.get(
      `${base.request}/orderSettlement/getSettleListByOrderId`,
      params
    )
  },
  // 订单结算详情-下半部分-结算情况
  getWorkTypeSettleList(params) {
    return http.get(
      `${base.request}/orderSettlement/getWorkTypeSettleList`,
      params
    )
  },
  // 添加审核
  addWorkAudit(params) {
    return http.post(`${base.request}/workAudit/addWorkAudit`, params)
  },
  // 审核详情
  getOrderDetail(params) {
    return http.get(`${base.request}/workAudit/getWorkTypeDetails`, params)
  },
}

const cooperative = {
  // 合作社列表查询
  cooperativeListFilter(params) {
    return http.get(`${base.request}/coo/getCooperativeList`, params)
  },
  addCooperative(params) {
    return http.post(`${base.request}/coo/addCooperative`, params)
  },
  // 申请审核列表
  applyExamineListFilter(params) {
    return http.post(
      `${base.request}/cooperativeAudit/cooperativeAuditList`,
      params
    )
  },
  // 获取申请审核信息
  getCooperativeApplyInfo(params) {
    return http.get(
      `${base.request}/cooperativeAudit/getCooperativeApplyById`,
      params
    )
  },
  // 审核操作
  cooperativeAudit(params) {
    return http.post(`${base.request}/cooperativeAudit/audit`, params)
  },
  // 获取申请详情信息
  getCooperativeApplyDetail(params) {
    return http.get(
      `${base.request}/cooperativeAudit/lookCooperativeInfo`,
      params
    )
  },
  // 获取散活作业列表
  getDisperseWorkList(params) {
    return http.post(
      `${base.request}/xScanCodeWork/selectXScanCodeWorkPage`,
      params
    )
  },
  getWorkList(params) {
    return http.get(
      `${base.request}/workType/getWorkTypeListByMasterId`,
      params
    )
  },
  getWorkTypeDetail(params) {
    return http.get(`${base.request}/workType/getWorkTypeDetails`, params)
  },
  getWorkTypeLandList(params) {
    return http.get(`${base.request}/workLand/getWorkTypeLandList`, params)
  },
  getWorkTypeTrajectory(params) {
    return http.get(`${base.request}/workLand/getWorkTypeTrajectory`, params)
  },
}
// 合同管理
const contract = {
  // 合同查询
  getContractList(params) {
    return http.get(`${base.request}/contract/getContractList`, params)
  },
  // 合同详情-上半部分
  getContractDetail(params) {
    return http.get(`${base.request}/contract/getEditContractDetail`, params)
  },
  // 合同详情-下半部分-合同订单
  getContractOrderList(params) {
    return http.get(`${base.request}/order/getContractOrderList`, params)
  },
  // 合同详情-下半部分-合同地块
  getContractDetailLands(params) {
    return http.get(
      `${base.request}/refContract/land/getContractDetailLands`,
      params
    )
  },
}
// 订单管理
const order = {
  // 获取订单列表
  getOrderList(params) {
    return http.post(`${base.request}/order/getOrderListByPage`, params)
  },
  // 获取订单详情-上半部分
  getOrderDetail(params) {
    return http.get(`${base.request}/order/getOrderDetail`, params)
  },
  // 获取订单详情-下半部分-订单作业地块
  getOrderLandList(params) {
    return http.get(`${base.request}/refOrder/land/getOrderLandList`, params)
  },
  // 获取订单详情-下半部分-订单作业地块筛选项
  getWorkTypeListFilter(params) {
    return http.get(`${base.request}/workType/workTypeList`, params)
  },
  // 获取订单详情-下半部分-订单完成情况数据
  getWorkTypeList(params) {
    return http.get(`${base.request}/workType/getWorkTypeList`, params)
  },
  // 获取订单详情-下半部分-订单支付记录
  getSettleList(params) {
    return http.get(`${base.request}/settle/getSettleListByOrderId`, params)
  },
  // 获取订单详情-下半部分-订单结算情况
  getWorkTypeSettleList(params) {
    return http.get(`${base.request}/workType/getWorkTypeSettleList`, params)
  },
}
// 作业相关
const work = {
  // 获取地块详情
  getLandDetail(params) {
    return http.get(`${base.request}/land/getLandDetail`, params)
  },
  getAssignWorks(params) {
    return http.get(`${base.request}/workAssign/getAssignWorks`, params)
  },
  // 获取地图右侧-地块信息
  getWorkLandDetails(params) {
    return http.get(`${base.request}/workLand/getWorkLandDetails`, params)
  },
  // 获取地图右侧-轨迹信息
  getLandTrajectoryInfo(params) {
    return http.get(`${base.request}/workLand/getLandTrajectoryInfo`, params)
  },
  // 获取地图右侧-派活信息
  getAssignDetails(params) {
    return http.get(`${base.request}/workAssign/getAssignDetails`, params)
  },
  // 散活详情-上半部分-机具信息
  getMachineDetailByMachineIdentity(params) {
    return http.get(
      `${base.request}/machine/selectMachineByMachineIdentity`,
      params
    )
  },
  // 散活详情-上半部分-作业信息
  getXScanCodeWorkById(params) {
    return http.get(
      `${base.request}/xScanCodeWork/getXScanCodeWorkById`,
      params
    )
  },
  // 散活详情-下半部分-作业轨迹
  getWorkTrajectory(params) {
    return http.post(
      `${base.request}/xScanCodeWork/selectWorkTrajectory`,
      params
    )
  },
  // 获取轨迹地块信息
  getTrajectoryLandInfo(params) {
    return http.get(`${base.request}/iot/work/getTrajectoryLandInfo`, params)
  },
}
// 演示
const show = {
  getLandTrajectoryInfoBlock(params) {
    return http.get(
      `${base.request}/iot/work/selTrajectoryLandByBlockNo`,
      params
    )
  },
}
// 系统设置
const setting = {
  // 获取登录日志列表
  getLogList(params) {
    return http.post(`${base.request}/log/list`, params)
  },
}
// 业务区域
const business = {
  // 根据区域id获取业务员列表
  getPersonListbyZoneId(params) {
    return http.get(`${base.request}/person/getPersonListbyZoneId`, params)
  },
  // 上移或者下移
  switchOrder(params) {
    return http.post(`${base.request}/zone/switchOrder`, params)
  },
  // 新增业务区域
  insertMBusinessZone(params) {
    return http.post(`${base.request}/zone/insertMBusinessZone`, params)
  },
  // 根据id修改业务区域名称
  updateMBusinessZoneNameById(params) {
    return http.post(`${base.request}/zone/updateMBusinessZoneNameById`, params)
  },
  // 根据id删除业务区域
  deleteMBusinessZoneNameById(params) {
    return http.get(`${base.request}/zone/deleteMBusinessZoneNameById`, params)
  },
  // 获取区域人员
  specifiedDutyList(params) {
    return http.get(`${base.request}/person/specifiedDutyList`, params)
  },
  // 指定区域负责人-修改
  specifiedDuty(params) {
    return http.post(`${base.request}/person/specifiedDuty`, params)
  },
  // 添加业务员---回显
  addPersonList(params) {
    return http.get(`${base.request}/person/addPersonList`, params)
  },
  // 添加业务员---批量添加
  batchAddPerson(params) {
    return http.post(`${base.request}/person/batchAddPerson`, params)
  },
  // 删除业务员---批量删除
  batchDelPerson(params) {
    return http.post(`${base.request}/person/batchDelPerson`, params)
  },
  // 变更负责客户
  updateCustomer(params, url) {
    return http.post(`${base.request}/${url}/updateCustomer`, params)
  },
}
// 北斗订单
const bdOrder = {
  // 北斗订单分页列表
  getOrderlist(params) {
    return http.post(`${base.request}/web/bdsOrder/bdOrderList`, params)
  },
  // 订单页面统计数据
  getStatistics(params) {
    return http.get(`${base.request}/web/bdsOrder/bdOrderTotal`, params)
  },
  // 北斗产品列表
  getProductList(params) {
    return http.get(`${base.request}/web/bdsOrder/bdOrderProducts`, params)
  },
  // 通过id获取订单详情
  getOrderDetailById(params) {
    return http.get(`${base.request}/web/bdsOrder/bdOrderDetail`, params)
  },
}
// 贷款订单
const loanOrder = {
  // 贷款订单分页列表
  getOrderlist(params) {
    return http.post(`${base.request}/psbc/getLoanApplyPage`, params)
  },
  // 统计数据
  getLoanStatistics(params) {
    return http.get(`${base.request}/psbc/getLoanApplyStatistic`, params)
  },
  // 通过id获取订单详情
  getOrderDetailById(params) {
    return http.get(`${base.request}/psbc/getLoanApplyDetail`, params)
  },
  // 通过id获取订单贴息详情
  getDiscountDetailById(params) {
    return http.get(`${base.request}/psbc/getLoanApplySubsidyDetail`, params)
  },
}
// 角色管理
const role = {
  // 角色列表(分页)
  getSRoleListNum(params) {
    return http.get(`${base.request}/manage/role/getSRoleListPage`, params)
  },
  // 修改角色
  updateSRole(params) {
    return http.post(`${base.request}/manage/role/UpdateSRole`, params)
  },
  // 新增角色
  addSRole(params) {
    return http.post(`${base.request}/manage/role/addSRole`, params)
  },
  // 删除角色
  delRole(params) {
    return http.get(`${base.request}/manage/role/delRole`, params)
  },
  // -删除成员角色
  delRefAccountRole(params) {
    return http.post(
      `${base.request}/manage/refAccountRole/delRefAccountRole`,
      params
    )
  },
  // - 配置权限
  setMenuForRole(params) {
    return http.post(`${base.request}/manage/role/setMenuForRole`, params)
  },
}
// 账号管理
const account = {
  // 账号列表
  getManageAccount(params) {
    return http.get(
      `${base.request}/manage/account/getManageAccountListPage`,
      params
    )
  },
  // 删除账号
  delManageAccount(params) {
    return http.get(`${base.request}/manage/account/delManageAccount`, params)
  },
  // 获取角色权限
  getAllSRoleList(params) {
    return http.get(`${base.request}/manage/role/getAllSRoleList`, params)
  },
  // 添加账号
  addManageAccount(params) {
    return http.post(`${base.request}/manage/account/addManageAccount`, params)
  },
  // 根据oa登录账号查账号信息
  getOaInfo(params) {
    return http.get(`${base.request}/manage/account/getOaInfo`, params)
  },
  // 修改角色
  updateRoleInfo(params) {
    return http.post(`${base.request}/manage/role/updateRoleInfo`, params)
  },
}

// 菜单管理
const menu = {
  // - 获取菜单列表
  selectAllSMenuTree(params) {
    return http.get(`${base.request}/menu/selectAllSMenuTree`, params)
  },
  // - 新增菜单
  insertSMenu(params) {
    return http.post(`${base.request}/menu/insertSMenu`, params)
  },
  // - 删除菜单
  deleteSMenuById(params) {
    return http.get(`${base.request}/menu/deleteSMenuById`, params)
  },
  // - 菜单详情
  selectSMenuDetailById(params) {
    return http.get(`${base.request}/menu/selectSMenuDetailById`, params)
  },
  // - 菜单详情
  updateSMenuById(params) {
    return http.post(`${base.request}/menu/updateSMenuById`, params)
  },
}

// 字典管理
const dict = {
  // 获取字典分页列表
  getDictList(params) {
    return http.post(`${base.request}/dict/selectDictList`, params)
  },
  // 插入字典
  insertDict(params) {
    return http.post(`${base.request}/dict/insertDict`, params)
  },
  // 修改字典
  updatDict(params) {
    return http.post(`${base.request}/dict/updateDictById`, params)
  },
  // 删除字典
  removeDict(params) {
    return http.post(`${base.request}/dict/deleteDictById`, params)
  },
  // 通过id获取子字典数据
  getDictDataById(params) {
    return http.post(`${base.request}/dict/selectChildrenById`, params)
  },
  // 根据code查询字典
  getCommonDict(code) {
    return http.post(`${base.request}/dict/selectChildrenByCode`, {
      code,
    })
  },
}
// 合作社基础信息
const basicInfo = {
  queryCoosByMasterId(params) {
    return http.get(`${base.request}/coo/queryCoosByMasterId`, params)
  },
  getMachineList(params) {
    return http.get(`${base.request}/machine/cMachineList`, params)
  },
  // 账号查询
  getCooAccountList(urlField, params) {
    return http.get(
      `${base.request}/${urlField}/account/${
        urlField == 'coo' ? 'getCooAccountPage' : 'getVillageAccountPage'
      }`,
      params
    )
  },
}
// 人员
const personnel = {
  // 查看页 获取人员详情
  getEmployeeDetail(params) {
    return http.get(`${base.request}/employee/getEmpBasicInfo`, params)
  },
}
// 县系统
const county = {
  // 分页查询县账号列表
  getCtCountyAccountPage(params) {
    return http.post(
      `${base.request}/ctCountyAccount/getCtCountyAccountPage`,
      params
    )
  },
  // 添加县账号
  addCtCountyAccount(params) {
    return http.post(
      `${base.request}/ctCountyAccount/addCtCountyAccount`,
      params
    )
  },
  // 更新县账号信息
  updateAccountInfo(params) {
    return http.post(
      `${base.request}/ctCountyAccount/updateAccountInfo`,
      params
    )
  },
  // 县账号详情
  getCtCountyAccountDetail(params) {
    return http.get(
      `${base.request}/ctCountyAccount/getCtCountyAccountDetail`,
      params
    )
  },
  // 县账号停用/启用
  updateStatus(params) {
    return http.get(`${base.request}/ctCountyAccount/updateStatus`, params)
  },
  // 重置密码
  updatePassword(params) {
    return http.post(`${base.request}/ctCountyAccount/updatePassword`, params)
  },
}

// 金融机构
const bank = {
  // 大托管-金融账号列表
  getFinanceAccounListPage(params) {
    return http.post(
      `${base.request}/financeAccount/getFinanceAccounListPage`,
      params
    )
  },
  // 单条新增金融机构账户表-主账号
  addFinanceAccount(params) {
    return http.post(`${base.request}/financeAccount/addFinanceAccount`, params)
  },
  // 根据id启用/停用金融机构账户表
  updateStatus(params) {
    return http.get(`${base.request}/financeAccount/updateStatus`, params)
  },
  // 根据id查询金融机构详情
  getFinanceAccountDetail(params) {
    return http.get(
      `${base.request}/financeAccount/getFinanceAccountDetail`,
      params
    )
  },
  // 根据id删除金融机构账户表
  deleteFinanceAccount(params) {
    return http.get(
      `${base.request}/financeAccount/deleteFinanceAccount`,
      params
    )
  },
  // 根据id重置密码
  updatePassword(params) {
    return http.post(`${base.request}/financeAccount/updatePassword`, params)
  },
  // 根据id修改金融机构账户表-主账号
  updateFinanceAccountById(params) {
    return http.post(
      `${base.request}/financeAccount/updateFinanceAccountById`,
      params
    )
  },
  // 银行机构列表
  fuzzyQueryList(params) {
    return http.get(
      `${base.request}/bank/fuzzyQuery`,
      params
    )
  },
  // 金融产品查询
  getFinanceProductList(params) {
    return http.post(
      `${base.request}/financeProduct/pageList`,
      params
    )
  },
  // 金融产品查询详情
  getSelectOneList(params) {
    return http.get(
      `${base.request}/financeProduct/selectOne`,
      params
    )
  },
  // 金融产品查询导出
  financeProductExport(params,fileName) {
    return http.exportWithBlob(
      `${base.request}/financeProduct/export`,
      params
    );
  },
  // 贷款意向查询列表
  getFinanceLoanIntentionList(params) {
    return http.post(
      `${base.request}/financeLoanIntention/pageList`,
      params
    )
  },
  // 贷款意向查询详情
  getLoanIntentionSelectOneList(params) {
    return http.get(
      `${base.request}/financeLoanIntention/selectOne`,
      params
    )
  },
  // 贷款意向查询列表导出
  financeLoanIntentionExport(params,fileName) {
    return http.exportWithBlob(
      `${base.request}/financeLoanIntention/export`,
      params
    );
  },
}

// 保险机构
const insure = {
  // 保险机构列表
  getInsureInfoListByPage(params) {
    return http.post(
      `${base.request}/insureInfo/getInsureInfoListByPage`,
      params
    )
  },
  // 停启用保险机构账号
  updateStatusInsure(params) {
    return http.get(`${base.request}/insureAccount/updateStatus`, params)
  },
  // 重置密码
  updatePasswordInsure(params) {
    return http.post(`${base.request}/insureAccount/updatePassword`, params)
  },
  // 获取账号详情
  getInsureAccountDetail(params) {
    return http.get(
      `${base.request}/insureAccount/getInsureAccountDetail`,
      params
    )
  },
  // 修改更新账号信息
  updateInsureAccountById(params) {
    return http.post(
      `${base.request}/insureAccount/updateInsureAccountById`,
      params
    )
  },
  // 保险机构
  queryInsurOreByKey(params) {
    return http.get(
      `${base.request}/insureOrgBase/queryInsurOreByKey`,
      params
    )
  },
  // 开通保险机构账号
  addInsurAccount(params) {
    return http.post(`${base.request}/insureAccount/addInsurAccount`, params)
  },
  // 保险产品查询
  getInsureProductList(params) {
    return http.post(
      `${base.request}/insureProduct/pageList`,
      params
    )
  },
  // 保险产品查询导出
  
  insureProductExport(params,fileName) {
    return http.exportWithBlob(
      `${base.request}/insureProduct/export`,
      params
    );
  },
  // 保险产品查询详情
  getInsureProductDetail(params) {
    return http.get(
      `${base.request}/insureProduct/detail`,
      params
    )
  },
  // 投保意向列表
  getInsureIntentionList(params) {
    return http.post(
      `${base.request}/insureIntention/pageList`,
      params
    )
  },
  // 投保意向列表导出
  insureIntentionExport(params,fileName) {
    return http.exportWithBlob(
      `${base.request}/insureIntention/export`,
      params
    );
  },
  // 投保意向详情 - 申请信息接口
  getInsureIntentionDetail(params) {
    return http.get(
      `${base.request}/insureIntention/detail`,
      params
    )
  },

}

// 供销社
const supply = {
  // 供销社列表
  getSupplyMarketList(params) {
    return http.get(
      `${base.request}/gxs/supplyMarketList`,
      params
    )
  },
  // 供销社用户添加
  supplyMarketAdd(params) {
    return http.post(`${base.request}/gxs/supplyMarketAdd`, params)
  },
  // 供销社用户重置密码
  updatePwd(params) {
    return http.post(
      `${base.request}/gxs/supplyMarketResetPwd`,
      params
    )
  },
  // 供销社用户修改
  userEdit(params) {
    return http.post(
      `${base.request}/gxs/userEdit`,
      params
    )
  },
  // 供销社用户停用启用
  userEnable(params) {
    return http.post(
      `${base.request}/gxs/userEnable`,
      params
    )
  },
}

// 生资运营-供应商模块
const supplierApi = {
  //添加供应商
  addSupplier(code) {
    return http.post(`${base.requestSz}/admin/enterprise/addEnterprise`, code)
  },
  //供应商列表
  getSupplierList(code) {
    return http.get(
      `${base.requestSz}/admin/enterprise/enterpriseInfoList`,
      code
    )
  },
  //查看供应商详情
  getSupplierDetail(code) {
    return http.get(
      `${base.requestSz}/admin/enterprise/getEnterpriseInfo`,
      code
    )
  },
  //编辑供应商
  getSupplierEdit(code) {
    return http.post(`${base.requestSz}/admin/enterprise/uptEnterprise`, code)
  },
  //删除供应商
  getSupplierRem(code) {
    return http.get(
      `${base.requestSz}/admin/enterprise/delEnterpriseInfo`,
      code
    )
  },
}

// 生资运营-品牌模块
const brandApi = {
  //添加品牌
  getAddbrand(data) {
    return http.post(`${base.requestSz}/admin/brand/addBrand`, data)
  },

  //查看品牌详情

  getBrandDetail(code) {
    return http.get(`${base.requestSz}/admin/brand/getBrandInfo`, code)
  },

  //品牌列表

  getBrandList(code) {
    return http.get(`${base.requestSz}/admin/brand/brandList`, code)
  },

  //删除品牌

  getBrandRem(code) {
    return http.get(`${base.requestSz}/admin/brand/delBrand`, code)
  },

  //修改品牌

  getBrandChanged(code) {
    return http.get(`${base.requestSz}/admin/brand/uptBrand`, code)
  },

  //删除提示

  getRemTitle(code) {
    return http.get(`${base.requestSz}/admin/product/checkDelProduct`, code)
  },
}

//商品管理

const orders = {
  // 三级列表

  ordersList(code) {
    return http.get(`${base.requestSz}/admin/szclassify/szClassifyList`, code)
  },
  // 商品分类

  ordersClass(code) {
    return http.get(
      `${base.requestSz}/admin/szclassify/szClassifyListForProduct`,
      code
    )
  },

  // 编辑三级列表

  editList(code) {
    return http.post(`${base.requestSz}/admin/szclassify/uptDtSzClassify`, code)
  },

  // 编辑滑块显示

  ordersShow(code) {
    return http.get(
      `${base.requestSz}/admin/szclassify/isShowDtSzClassify`,
      code
    )
  },

  // 添加分类

  addFenlei(code) {
    return http.post(
      `${base.requestSz}/admin/szclassify/saveDtSzClassify`,
      code
    )
  },

  // 删除分类

  remFenlei(code) {
    return http.get(`${base.requestSz}/admin/szclassify/delDtSzClassify`, code)
  },

  // 商品列表
  commodityList(code) {
    return http.get(`${base.requestSz}/admin/product/productsList`, code)
  },
  // 商品详情
  detailOrder(code) {
    return http.get(
      `${base.requestSz}/admin/product/getSzProductsSpuInfo`,
      code
    )
  },
  // 添加商品
  addOrder(code) {
    return http.get(`${base.requestSz}/admin/product/addProduct`, code)
  },
    // 编辑商品
  ordersAmend(code) {
      return http.post(`${base.requestSz}/admin/product/uptProduct`, code)
  },
  //商品上下架
  uptStatus(code) {
    return http.get(`${base.requestSz}/admin/product/uptStatus`, code)
  },
  //商品分类
  classList(code) {
    return http.get(`${base.requestSz}/admin/szclassify/szClassifyList`, code)
  },
  //供应商列表
  enterpriseInfoList(code) {
    return http.get(
      `${base.requestSz}/admin/enterprise/enterpriseInfoList`,
      code
    )
  },
  //品牌列表
  brandNameList(code) {
    return http.get(`${base.requestSz}/admin/brand/brandList`, code)
  },
}

//生资运营-订单管理
const szOrder = {
  // 查询账号信息
  getAccountInfo(params, systemType, loginAccount) {
    return http.post(
      `${base.request}/manage/account/getAccountInfo?systemType=${systemType}&loginAccount=${loginAccount}`,
      params
    )
  },

  // 查询地址列表
  getAddressPaginator(params) {
    return http.post(`${base.request}/web/bdsOrder/addressPaginator`, params)
  },

  // 订单列表
  getOrderPage(params) {
    return http.post(`${base.requestSz}/admin/order/getOrderPage`, params)
  },

  // 物流信息查看
  getLogistics(params) {
    return http.get(`${base.requestSz}/admin/order/getLogistics`, params)
  },

  // 取消订单
  getDelOrder(params) {
    return http.get(`${base.requestSz}/admin/order/delOrder`, params)
  },

  // 订单备注
  editOrderRemarks(params) {
    return http.get(`${base.requestSz}/admin/order/editOrderRemarks`, params)
  },

  // 修改费用
  editCost(params) {
    return http.get(`${base.requestSz}/admin/order/editCost`, params)
  },

  // 修改收货人信息
  editConsignee(params) {
    return http.get(`${base.requestSz}/admin/order/editConsignee`, params)
  },

  // 修改发票信息
  editInvoice(params) {
    return http.get(`${base.requestSz}/admin/order/editInvoice`, params)
  },

  // 确定定价
  confirmPricing(params) {
    return http.get(`${base.requestSz}/admin/order/confirmPricing`, params)
  },

  // 确认发货
  confirmDelivery(params) {
    return http.get(`${base.requestSz}/admin/order/confirmDelivery`, params)
  },

  // 付款核实
  confirmPayment(params) {
    return http.get(`${base.requestSz}/admin/order/confirmPayment`, params)
  },

  // 修改商品
  editGoods(params) {
    return http.get(`${base.requestSz}/admin/order/editGoods`, params)
  },

  // 添加商品查询列表
  getListByName(params) {
    return http.get(`${base.requestSz}/admin/product/getListByName`, params)
  },

  // 查询商品详情
  getInfo(params) {
    return http.get(`${base.requestSz}/admin/product/getInfo`, params)
  },

  // 添加订单
  addOrderInfo(params) {
    return http.post(`${base.requestSz}/admin/order/addOrderInfo`, params)
  },

  // 订单详情
  getOrder(params) {
    return http.get(`${base.requestSz}/admin/order/getOrder`, params)
  },

  // 删除订单
  deleteOrder(params) {
    return http.get(`${base.requestSz}/admin/order/delete`, params)
  },
}

// 设备管理模块
const agrModel = {
  //土壤实时数据查询
  getRealSoil(params) {
      return http.get(`${base.request}/monitor/soil/v1/getSoilCurrent`, params)
  },
  //土壤历史数据查询
  getRealSoilAll(params) {
      return http.get(`${base.request}/monitor/soil/v1/getSoilHistory`, params)
  },
  //视频监测获取播放地址
  getVideoUrl(params) {
      return http.get(`${base.request}/video/getHKYSLiveListByDeviceSerial`, params)
  },
  //视频监测云台操作
  getVideoStatus(params) {
      return http.get(`${base.request}/video/hkysStartYTControll`, params)
  },
  //停止视频监测云台操作
  getVideoStop(params) {
      return http.get(`${base.request}/video/hkysStopYTControll`, params)
  },
  //长势图片查询
  getSiteImage(params) {
      return http.get(`${base.request}/video/findFarmDtMediaPic`, params)
  },
  //气象实时数据查询
  getWeather(params) {
      return http.get(`${base.request}/environment/realTime`, params)
  },
  //气象历史数据查询
  getWeatherAll(params) {
      return http.get(`${base.request}/environment/getHistory`, params)
  },
  //云台拍照
  getPhotograph(params) {
      return http.get(`${base.request}/video/hkysLiveCapture`, params)
  },
  // 获取布置设备列表
  getDevList(params) {
      return http.get(`${base.request}/monitor/v1/getDevicePageList`, params);
  },
  // 添加设备
  addDevList(params) {
      return http.post(`${base.request}/monitor/v1/addDevice`, params);
  },
  // 编辑设备
  editDevList(params) {
      return http.post(`${base.request}/monitor/v1/updateDevice`, params);
  },
  // 获取绑定地块数据
  getMapLand(params) {
      return http.get(`${base.request}/monitor/manage/v1/getLandList`, params);
  },
  // 解除绑定
  setDevBind(params) {
      return http.get(`${base.request}/monitor/manage/v1/updateLandBind`, params);
  },
  // 提交并回显地块和设备
  goBackDevBind(params) {
      return http.post(`${base.request}/monitor/manage/v1/getLandBind`, params);
  },
  // 获取当前地块信息详情
  getLandInfoDetail(params) {
      return http.get(`${base.request}/land/getLandDetail`, params);
  },
  // 获取绑定完成显示信息
  getLandBindInfo(params) {
      return http.get(`${base.request}/monitor/manage/v1/getLandInfo`, params);
  },
  setLandBindData(params) {
      return http.post(`${base.request}/monitor/manage/v1/addLandBind`, params);
  },
  //获取拍摄点
  getPresetGet(params) {
      return http.get(`${base.request}/video/presetGet`, params);
  },
  //添加拍摄点
  getPresetAdd(params) {
      return http.get(`${base.request}/video/presetAdd`, params);
  },
  //删除拍摄点
  getPresetDel(params) {
      return http.get(`${base.request}/video/presetDel`, params);
  },
  //回到拍摄点
  getPresetMove(params) {
      return http.get(`${base.request}/video/presetMove`, params);
  },

};

// 农情监测首页
const nqMonitor = {
  // 地块、设备显示
  monitorDevice(params) {
      return http.get(
          `${base.request}/monitor/manage/v1/getLandAndDeviceList`,
          params
      );
  },
  // 土壤实时
  monitorSoil(params) {
      return http.get(`${base.request}/monitor/soil/v1/getSoilCurrent`, params);
  },
  // 环境实时
  monitorEnv(params) {
      return http.get(`${base.request}/environment/realTime`, params);
  },
  // 土壤/环境实时V4
  monitorGroupV4(params) {
      return http.get(`${base.request}/monitor/v4/queryLastGroupDataInfo`, params);
  },
  // 土壤/环境历史V4
  monitorHisGroupV4(params) {
      return http.get(`${base.request}/monitor/getV4History`, params);
  },
  // 长势图片
  monitorGrow(params) {
      return http.get(`${base.request}/video/findFarmDtMediaPic`, params);
  },
  // 长势图片
  picLately(params) {
      return http.get(`${base.request}/video/findFarmDtMediaPicLately`, params);
  },
  // 获取播放地址
  videoPlayAddress(params) {
      return http.get(
          `${base.request}/video/getHKYSLiveListByDeviceSerial`,
          params
      );
  },
  // 云台控制
  videoControl(params) {
      return http.get(`${base.request}/video/hkysStartYTControll`, params);
  },
  // 停止云台
  stopControl(params) {
      return http.get(`${base.request}/video/hkysStopYTControll`, params);
  },
    // 搜索 合作社列表
    listOfCooperatives(params) {
      return http.get(`${base.request}/monitor/manage/v1/queryCooperativeVoList`, params);
  },
};

export default {
  login,
  common,
  village,
  cooperative,
  contract,
  order,
  work,
  show,
  setting,
  business,
  bdOrder,
  loanOrder,
  role,
  account,
  menu,
  dict,
  basicInfo,
  personnel,
  county,
  bank,
  insure,
  supply,
  supplierApi,
  brandApi,
  orders,
  szOrder,
  agrModel,
  nqMonitor,
}
